module.exports = __webpack_public_path__ + "img/logo-icon.eb83bd00.png";